import { InjectionToken } from '@angular/core';

// Gates the beta "order in pharmacy" action for drug prescriptions.
// Portals provide it disabled on the live production build so the unfinished
// flow stays hidden there. Absent provider (or `false`) keeps the action hidden.
export const PHARMACY_ORDER_ENABLED = new InjectionToken<boolean>('PHARMACY_ORDER_ENABLED');
